
import { defineComponent } from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  name: 'WhatMakesFCCard',
  components: {
    FCImage,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { modalShow } = useModal({
      component: () => import('./WhatMakesFCModal.vue'),
      componentProps: { product: props.card },
      modalProps: {
        componentName: 'ExploreFCModal',
        width: process.client ? Math.min(800, Math.floor(window?.innerWidth * 0.85)) : 'auto',
        height: process.client ? Math.min(800, Math.floor(window?.innerHeight * 0.85)) : 'auto',
        reset: true,
        classes: 'modal-mobile-full-screen',
      },
    });

    function openModal() { modalShow(); }

    return {
      openModal,
    };
  },
});
